var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.0745392,3.0001647v0.0016294H4.91856c-1.0400367-0.0117493-1.9058578,0.8339601-1.9185448,1.873997v22.2479706 c0.0122156,1.0406151,0.877924,1.8872528,1.9185448,1.8760872h22.1559792 c1.0431728,0.0131435,1.9119148-0.8333759,1.9258728-1.8760872V4.8742795 C28.986454,3.8320341,28.1165447,2.9864426,27.0745392,3.0001647z M10.7110462,25.1538124H6.854547V12.7466192h3.8564992 V25.1538124z M11.0200434,8.8151045c0,1.226222-1.008975,2.2354431-2.2352076,2.2355604c-0.0002356,0-0.0003481,0-0.0004711,0 c-1.2264576,0-2.2356787-1.0091028-2.2356787-2.2355604c0-1.2264681,1.0092211-2.2356839,2.2356787-2.2356839 c1.2263556,0,2.2354536,1.008985,2.2356787,2.2352176C11.0200434,8.8147507,11.0200434,8.8148689,11.0200434,8.8151045z  M25.1540165,25.1538124h-3.8525429v-6.0332222c0-1.4387035-0.0257015-3.2907228-2.0036755-3.2907228 c-2.0065842,0-2.3136044,1.5674448-2.3136044,3.1859388v6.1375408h-3.8524313V12.7466192h3.6983423v1.6954823h0.0518646 c0.7530231-1.2875156,2.1583481-2.0593729,3.6490402-2.0040188c3.904644,0,4.6246357,2.5682926,4.6246357,5.9096003 L25.1540165,25.1538124z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSmall);
export default __webpack_public_path__ + "static/media/linkedin--small.6e179c9abf5a8b2268eb9d1df5384254.svg";
export { ForwardRef as ReactComponent };